import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DataAttributes } from 'src/types/utils';
const sizeStyles = {
  small: css`
    padding: 0 3px;
    border-radius: 6px;
    height: 12px;
    min-width: 4px;

    font-size: 10px;
  `,
  big: css`
    padding: 0 3px;
    border-radius: 8px;
    height: 14px;
    min-width: 8px;

    font-size: 12px;
  `
} as const;
type BadgeSize = keyof typeof sizeStyles;
const NumberRootStyle = styled.span<{
  size: BadgeSize;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  border-width: 1px;
  border-style: solid;
  border-color: transparent;

  background-color: ${({
  theme
}) => theme.color.accentA1};
  color: ${({
  theme
}) => theme.color.contentBrightFixed};

  font-weight: 700;

  ${({
  size
}) => sizeStyles[size]}
`;
const DefaultRootStyle = styled.span`
  background-color: ${({
  theme
}) => theme.color.accentA1};
  width: 14px;
  height: 14px;
  border-radius: 50%;
`;
type BaseBadgeProps = DataAttributes & Pick<ComponentProps<'span'>, 'className'>;
interface NumberBadgeProps extends BaseBadgeProps {
  type: 'number';
  size?: BadgeSize;
  value: number;
}
interface DefaultBadgeProps extends BaseBadgeProps {
  type: 'default';
}
type Props = NumberBadgeProps | DefaultBadgeProps;
const Badge = (props: Props) => {
  if (props.type === 'number') {
    const {
      size = 'small',
      value,
      ...restProps
    } = props;
    return <NumberRootStyle size={size} {...restProps}>
        {value > 99 ? '99+' : value}
      </NumberRootStyle>;
  }
  return <DefaultRootStyle {...props} data-sentry-element="DefaultRootStyle" data-sentry-component="Badge" data-sentry-source-file="index.tsx" />;
};
export default Badge;